import { render, staticRenderFns } from "./TakeScreenshot.vue?vue&type=template&id=398fdcc1&"
import script from "./TakeScreenshot.vue?vue&type=script&lang=js&"
export * from "./TakeScreenshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports